module.exports = __webpack_public_path__ + "img/1791982309343.e575b478.png";